import { render, staticRenderFns } from "./AbkRecipientGroupForm.vue?vue&type=template&id=6de9e0e6&scoped=true&"
import script from "./AbkRecipientGroupForm.vue?vue&type=script&lang=js&"
export * from "./AbkRecipientGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkRecipientGroupForm.vue?vue&type=style&index=0&id=6de9e0e6&scoped=true&lang=scss&"
import style1 from "./AbkRecipientGroupForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9e0e6",
  null
  
)

export default component.exports